import { ListingBuyerAlertModel } from '@steelbuy/ts-shared';

import { createCollectionDataContext } from '../../util/provider/CollectionDataProvider';

export const ListingBuyerAlertCollectionData = createCollectionDataContext<ListingBuyerAlertModel>();
